var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"screen-scale-wrapper"},[_c('div',{staticClass:"screen-scale-inner",style:(_vm.innerStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }